export default __webpack_public_path__ + "static/media/logo-lg-480w.53b45653.png";